import { TABLE_COLUMNS_MESSAGES, TableColumnsMessages } from "../tables/columns.messages";

export type WorkflowTableMessages = TableColumnsMessages & {
  nameColumn: string;
  triggerColumn: string;
  descriptionColumn: string;
  statusColumn: string;
  optionsColumn: string;

  //Agente  messages
  activeWorkflowConflictMessage: string;
  operationNotAllowedForStartFlow: string;
  activateStartFlowFirst: string;
};

export const WORKFLOW_TABLE_MESSAGES: WorkflowTableMessages = {
  nameColumn: "Nome",
  triggerColumn: "Tipo do agente",
  descriptionColumn: "Descrição",
  statusColumn: "Status",

  //Agente messages
  activeWorkflowConflictMessage:
    "Já existe um agente ativo com este tipo. Desative o outro agente antes de ativar este.",
  operationNotAllowedForStartFlow: "Operação não permitida para Iniciar Fluxo.",
  activateStartFlowFirst: "Ative um agente do tipo Iniciar Fluxo primeiro.",

  ...TABLE_COLUMNS_MESSAGES,
};
